import React, { useState, useEffect } from "react";
import arrowIcon from '../assets/images/icons/arrow-angle-down-icon.svg';

const CoinSelectDropdown = ({ options, onSelect, placeholder, placeholderIcon, className }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState(options && options[0] ? options[0] : null);

    useEffect(() => {
        if (options && options.length > 0) {
            setSelectedValue(options[0]); // Select the first option by default
            onSelect(options[0]); // Notify parent about the default selection
        }
    }, [options]);

    const handleSelect = (option) => {
        setSelectedValue(option);
        onSelect(option); // Pass the selected option to the parent
        setIsOpen(false);
    };

    return (
        <div className={`custom-select ${className}`}>
            <div className="select-header" onClick={() => setIsOpen(!isOpen)}>
                <div className="name-wrapper">
                    <div className="icon">
                        <img
                            src={selectedValue ? selectedValue.icon : placeholderIcon}
                            alt="icon"
                            className="coin-img"
                        />
                    </div>
                    <div className="content">
                        <p className="p w-600">{selectedValue ? selectedValue.label : placeholder}</p>
                    </div>
                </div>
                <div className="arrow-wrapper">
                    <p className="p w-600">{selectedValue ? selectedValue.shortName : ""}</p>
                    <a href="#" className={`arrow ${isOpen ? "open" : ""}`}>
                        <img src={arrowIcon} alt="icon" />
                    </a>
                </div>
            </div>
            {isOpen && (
                <ul className="select-options">
                    {options.map((option, index) => (
                        <li
                            key={index}
                            onClick={() => handleSelect(option)}
                            className="select-option"
                        >
                            <a href="#" className={`option-card ${selectedValue == option ? "active" : ""}`}>
                                <div className="option-name">
                                    <div className="icon-wrapper">
                                        <img src={option.icon} alt={option.label} className="coin-img" />
                                    </div>
                                    <p className="p w-600">{option.label}</p>
                                </div>
                                <p className="p w-600">{option.shortName}</p>
                            </a>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default CoinSelectDropdown;
